import {useTranslation} from 'react-i18next';
import {Preset} from '../../../layout/admin/AdminFormHeader';

export const ORGANIZATIONAL_UNIT_PRESETS: Preset[] = [
  {label: 'Church', alias: 'church'},
  {label: 'Administrative', alias: 'administrative'}
];

export const useOrganizationalUnitPresets = (): Preset[] => {
  const {t} = useTranslation();
  return [
    {label: t('admin.organizationalUnits.presets.church'), alias: 'church'},
    {label: t('admin.organizationalUnits.presets.administrative'), alias: 'administrative'}
  ];
};

export const DEFAULT_ORGANIZATIONAL_UNIT_PRESET = 'church';

